export default __webpack_public_path__ + "static/media/3.b37041e8.jpg";